import de from '@translations/de/brandsTable.json';
import en from '@translations/en/brandsTable.json';
import pl from '@translations/pl/brandsTable.json';
import sl from '@translations/sl/brandsTable.json';
import uk from '@translations/uk/brandsTable.json';
import bg from '@translations/bg/brandsTable.json';
import cz from '@translations/cz/brandsTable.json';
import fr from '@translations/fr/brandsTable.json';
import gr from '@translations/gr/brandsTable.json';
import it from '@translations/it/brandsTable.json';
import pr from '@translations/pr/brandsTable.json';
import ru from '@translations/ru/brandsTable.json';
import sk from '@translations/sk/brandsTable.json';
import sp from '@translations/sp/brandsTable.json';
import tr from '@translations/tr/brandsTable.json';
import hu from '@translations/hu/brandsTable.json';
import { ITranslations } from '@/types/common';
import { BrandsTableTransFields } from './types';

export const brandsTableTranslations: ITranslations<BrandsTableTransFields> = {
  name: 'brandsTable',
  de,
  en,
  pl,
  sl,
  uk,
  bg,
  cz,
  fr,
  gr,
  it,
  pr,
  ru,
  sk,
  sp,
  tr,
  hu,
};
